import Login from "views/SignInView";

export default function Page() {
  return (
    <>
      <Login />
    </>
  );
}
